import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../../services/api";
import { Load } from "../../../Load";
import { CardContent } from "@mui/material";
import AlertMessage from "../../../Alert";
import { Options, Select } from "../../../Select";
import { Button } from "react-bootstrap";
import './style.css';
import { CadastroContext } from "../../../../contexts/CadastroContext";

const AsoSelecionarResponsavel = () => {
    const navigate = useNavigate();
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
    const [responsavelSelecionado, setResponsavelSelecionado] = useState<any>(null);
    const [responsaveis, setResponsaveis] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isDisabled, setIsDisabled] = useState(true);

    const handleContinuar = () => {
        if (responsavelSelecionado) {
            cadastro.responsavel.id = responsavelSelecionado!.id;
            cadastro.responsavel.nome = responsavelSelecionado!.nome;
            if (cadastro.responsavel.id && cadastro.responsavel.nome) {
                handleCadastroChange(cadastro);
                return navigate('/aso/registro/validar-identidade-empresa');
            }
            setAlert({ show: true, message: "Selecione um responsável antes de prosseguir.", variant: "danger" });
        } else {
            setAlert({ show: true, message: "Selecione um responsável antes de prosseguir.", variant: "danger" });
        }
    }

    const handleVoltar = () => {
        return navigate('/aso/registro/validar-documentos-empresa');
    }

    const handleResponsavelSelecionado = (event: any) => {
        if (event) {
            setResponsavelSelecionado(event);
            setIsDisabled(false);
        } 
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.get('listar-responsaveis-empresa');
                if (response.status === 200) {
                    setResponsaveis(response.data);
                    setIsLoading(false);
                }
            } catch (error) {
                setIsLoading(false);
                setAlert({ show: true, message: "Erro ao listar responsáveis.", variant: "danger" });
            }
        }

        fetchData();
    }, []);

    return(
        <>
            <Load isLoading={isLoading} />
            {!isLoading && (
                <>
                    <div className="aso-container-responsavel">
                        <div className="aso-titulo-responsavel">Qual é o responsável pela empresa?</div>
                        <CardContent className="aso-card-responsavel">
                        <div className="aso-card-content-responsavel">
                            <label htmlFor="responsaveis" className="label-container">
                                O responsável é o médico encarregado de verificar e assinar o seu documento.
                            </label>
                            <Select width="600px" 
                                id="responsaveis" 
                                onSelect={handleResponsavelSelecionado}>
                                {responsaveis.map((reponsavel: any) => (
                                    <Options key={reponsavel.id} value={reponsavel} name={reponsavel.nome} />
                                ))}
                            </Select>
                        </div>
                        </CardContent>
                        <div className="aso-button-container">
                        <Button variant="primary" className="aso-button" onClick={handleVoltar}>
                            Voltar
                        </Button>
                        <Button variant="primary" className="aso-button" onClick={handleContinuar} disabled={isDisabled}>
                            Continuar
                        </Button>
                        </div>
                    </div>
                    <AlertMessage
                        show={alert.show}
                        message={alert.message}
                        variant={alert.variant}
                        onClose={() => setAlert({ ...alert, show: false })}
                    />
                </>
            )}
        </>
    );
}

export default AsoSelecionarResponsavel;